export default function ReadDoubleTickIcon({
  className = "",
}: {
  className?: string;
}) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.03765 4.04537C9.21967 4.20428 9.23841 4.48065 9.0795 4.66267L4.49617 9.91267C4.41309 10.0078 4.29292 10.0624 4.16659 10.0624C4.04026 10.0624 3.9201 10.0078 3.83702 9.91267L2.00368 7.81267C1.84478 7.63065 1.86351 7.35427 2.04553 7.19537C2.22755 7.03646 2.50393 7.0552 2.66283 7.23722L4.16659 8.95971L8.42035 4.08722C8.57925 3.9052 8.85563 3.88646 9.03765 4.04537Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9684 4.09463C12.1434 4.26127 12.1501 4.53819 11.9835 4.71316L6.98336 9.96316C6.89499 10.0559 6.77039 10.1053 6.64246 10.0983C6.51452 10.0912 6.39611 10.0284 6.31848 9.92648L6.06863 9.59835C5.92225 9.40611 5.95942 9.13161 6.15166 8.98523C6.3168 8.85948 6.54267 8.86919 6.69585 8.99631L11.3499 4.1097C11.5165 3.93474 11.7935 3.92799 11.9684 4.09463Z"
        fill="white"
      />
    </svg>
  );
}
